import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Mail, Phone, MapPin } from "lucide-react";
import { LogoMark } from "./Logo";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const subscribe = () => {
    if (!email.includes("@")) {
      toast.error("Introduce un email válido");
      return;
    }
    toast.success("¡Bienvenido a hylasu! Tu 10% de descuento está en camino.");
    setEmail("");
  };

  return (
    <footer data-testid="brand-footer" className="bg-stone-950 px-6 py-20 text-stone-100">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-14 lg:grid-cols-[1.2fr_1fr_1fr_1fr]">
          <div>
            <span className="flex items-center gap-2.5 text-stone-50">
              <LogoMark />
              <span className="font-serif text-2xl font-medium tracking-tight">Hylasu</span>
            </span>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-stone-400">
              Esculturas de luz artesanales para hogares que respiran calma.
            </p>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-amber-400/90">
              10% en tu primera pieza
            </p>
            <div className="mt-3 flex max-w-sm overflow-hidden rounded-full border border-stone-700 focus-within:border-amber-500">
              <input
                data-testid="newsletter-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                className="flex-1 bg-transparent px-5 py-3 text-sm text-stone-100 outline-none placeholder:text-stone-500"
              />
              <button
                data-testid="newsletter-subscribe-button"
                onClick={subscribe}
                aria-label="Suscribirse"
                className="bg-stone-100 px-5 text-stone-900 transition-colors hover:bg-amber-400"
              >
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone-500">Filosofía</p>
            <ul className="mt-4 space-y-2.5 text-sm text-stone-400">
              <li className="transition-colors hover:text-stone-100">Nuestro taller</li>
              <li className="transition-colors hover:text-stone-100">Materiales nobles</li>
              <li className="transition-colors hover:text-stone-100">Colección Ethereal</li>
              <li className="transition-colors hover:text-stone-100">Sostenibilidad</li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone-500">Contacto</p>
            <ul className="mt-4 space-y-3 text-sm text-stone-400">
              <li>
                <a data-testid="contact-email-1" href="mailto:moiseslaham@gmail.com" className="flex items-center gap-2.5 transition-colors hover:text-stone-100">
                  <Mail size={14} className="shrink-0 text-amber-400" /> moiseslaham@gmail.com
                </a>
              </li>
              <li>
                <a data-testid="contact-email-2" href="mailto:jimmylaham@me.com" className="flex items-center gap-2.5 transition-colors hover:text-stone-100">
                  <Mail size={14} className="shrink-0 text-amber-400" /> jimmylaham@me.com
                </a>
              </li>
              <li>
                <a data-testid="contact-phone-1" href="tel:+525533962857" className="flex items-center gap-2.5 transition-colors hover:text-stone-100">
                  <Phone size={14} className="shrink-0 text-amber-400" /> +52 55 3396 2857
                </a>
              </li>
              <li>
                <a data-testid="contact-phone-2" href="tel:+525529790131" className="flex items-center gap-2.5 transition-colors hover:text-stone-100">
                  <Phone size={14} className="shrink-0 text-amber-400" /> +52 55 2979 0131
                </a>
              </li>
              <li data-testid="contact-address" className="flex items-start gap-2.5">
                <MapPin size={14} className="mt-0.5 shrink-0 text-amber-400" />
                <span>Av. Loma de la Palma 6,<br />Huixquilucan, Edo. de México</span>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone-500">Pago seguro</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["VISA", "MASTERCARD", "APPLE PAY", "PAYPAL", "KLARNA"].map((p) => (
                <span key={p} className="rounded-md border border-stone-700 px-2.5 py-1 font-mono text-[10px] tracking-wider text-stone-400">
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-stone-800 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-stone-500">© 2026 hylasu — Esculturas de Luz. Todos los derechos reservados.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-stone-600">Diseñado para la calma</p>
        </div>
      </div>
    </footer>
  );
};
